const digest = '216ee155994d6954955dcf50c730691e6824a2a81f837f30744d6781beb51149';
const css = `*,:after,:before{box-sizing:border-box}html{-ms-overflow-style:-ms-autohiding-scrollbar}#root,body,html{height:100%;margin:0}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default {  };

export { css, digest };